import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const LINKS = [
  { label: "Portfolio", id: "portfolio" },
  { label: "Über", id: "about" },
  { label: "Kontakt", id: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 1.4, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-pearl/80 backdrop-blur-md border-b border-line/60" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="mx-auto max-w-[1400px] px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          onClick={() => go("top")}
          data-testid="nav-logo"
          className="flex items-center"
        >
          <img src="/img/logo.png" alt="Janna Schwartz" className="h-8 md:h-20 w-auto object-contain" />
        </button>
        <ul className="flex items-center gap-6 md:gap-10">
          {LINKS.map((l) => (
            <li key={l.id}>
              <button
                onClick={() => go(l.id)}
                data-testid={`nav-${l.id}`}
                className="relative group text-xs md:text-[13px] tracking-[0.18em] uppercase text-stone hover:text-charcoal transition-colors pb-1.5"
              >
                {l.label}
                <span className="absolute bottom-0 left-0 w-full h-[1px] bg-charcoal scale-x-0 origin-left transition-transform duration-300 ease-out group-hover:scale-x-100" />
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </motion.header>
  );
}
